/*
 * 着陆页「本次会话已看过」的状态。
 *
 * 为什么不用组件实例变量 / 模块级变量：
 *   Flarum 是单页应用，点页眉 Logo 回到 '/' 时组件不销毁，实例变量会一直有效；
 *   但一旦发生**整页跳转或刷新**（普通 <a href> 没被 mithril 拦截时就会发生），
 *   JS 全部重载，模块级变量清零，着陆页就会再次糊上来。
 *
 * 改成 sessionStorage 后：同一浏览器标签页会话内，
 *   无论 SPA 路由跳转、整页跳转、F5 刷新 —— 都只显示一次。
 *   关闭标签页 / 新开会话才会重新出现（符合「一次访问看一次」的预期）。
 *
 * 调试：?landing=preview 会绕过本状态强制显示。
 */
const KEY = 'acmeLandingSeen';

export function isLandingSeen() {
  try {
    return window.sessionStorage.getItem(KEY) === '1';
  } catch (e) {
    // 隐私模式等禁用 storage 的场景，退化为「每次都显示」
    return false;
  }
}

export function markLandingSeen() {
  try {
    window.sessionStorage.setItem(KEY, '1');
  } catch (e) {
    // 忽略：storage 不可用时只是无法记住，不影响主流程
  }
}

export function resetLandingSeen() {
  try {
    window.sessionStorage.removeItem(KEY);
  } catch (e) {
    // 忽略
  }
}
